import { React } from "react";
import {Link, Outlet} from "react-router-dom";


const Back = () => {
    return (
        <Link to={'/'}>
            <svg width="100" height="46" viewBox="0 0 113 52" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_53_30)">
<path d="M107.5 17C107.5 9.54416 101.456 3.5 94 3.5H19C11.5442 3.5 5.5 9.54416 5.5 17V31C5.5 38.4558 11.5442 44.5 19 44.5H94C101.456 44.5 107.5 38.4558 107.5 31V17Z" stroke="#85B9E9" strokeWidth="3"/>
<path d="M92.9399 22.4301H27.4686L34.9466 13.3994C35.2963 12.9764 35.4645 12.4311 35.4143 11.8834C35.3641 11.3357 35.0995 10.8305 34.6788 10.479C34.2581 10.1274 33.7158 9.95827 33.171 10.0088C32.6263 10.0593 32.1238 10.3253 31.7741 10.7482L21.4738 23.1757C21.4045 23.2745 21.3425 23.3784 21.2884 23.4864C21.2884 23.5899 21.2884 23.6521 21.1442 23.7556C21.0508 23.9931 21.0019 24.2459 21 24.5013C21.0019 24.7567 21.0508 25.0095 21.1442 25.2469C21.1442 25.3505 21.1442 25.4126 21.2884 25.5162C21.3425 25.6242 21.4045 25.728 21.4738 25.8269L31.7741 38.2543C31.9678 38.4882 32.2104 38.6762 32.4845 38.8051C32.7587 38.9339 33.0577 39.0005 33.3604 39C33.8417 39.0009 34.3082 38.8324 34.6788 38.5236C34.8874 38.3497 35.0599 38.1362 35.1863 37.8952C35.3126 37.6542 35.3905 37.3905 35.4154 37.1192C35.4403 36.848 35.4117 36.5744 35.3312 36.3143C35.2508 36.0541 35.1201 35.8125 34.9466 35.6032L27.4686 26.5725H92.9399C93.4863 26.5725 94.0103 26.3543 94.3966 25.9659C94.783 25.5774 95 25.0506 95 24.5013C95 23.952 94.783 23.4251 94.3966 23.0367C94.0103 22.6483 93.4863 22.4301 92.9399 22.4301Z" fill="#85B9E9"/>
</g>
<defs>
<filter id="filter0_d_53_30" x="0" y="0" width="113" height="52" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="2"/>
<feGaussianBlur stdDeviation="2"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_53_30"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_53_30" result="shape"/>
</filter>
</defs>
</svg>
        </Link>

    )}

    export default Back
